<template>
    <div>
        <div class="table-responsive">
            <table class="table mb-0 table-bordered">
                <thead>
                    <tr>
                        <th>権限</th>
                        <th>日時</th>
                        <th>名称</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in dataHistory" :key="'c' + item.id">
                        <td>{{ item.user && item.user.role ? $t(item.user.role.name) : '' }}</td>

                        <td>{{ formatDateCommon(item.created_at, 'dateTimeJP') ?? '' }}</td>
                        <td>{{ item.user ? item.user.name : '' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { formatDateCommon } from '@/utils/format';

export default {
    name: 'TabHistories',
    props: {
        dataHistory: Array,
        default: () => []
    },
    methods: {
        formatDateCommon(date, type) {
            return formatDateCommon(date, type);
        }
    }
};
</script>

<style lang="scss" scoped></style>
